import { cn } from "../../lib/utils";

const ROW_LEAD_WIDTHS = ["w-3/4", "w-1/2", "w-2/3", "w-5/6", "w-3/5", "w-4/5"];

export const TableBackdrop = () => (
  <div className="flex h-full w-full flex-col gap-3 overflow-hidden p-4">
    <div className="h-4 w-full shrink-0 rounded-sm bg-foreground/25" />
    {ROW_LEAD_WIDTHS.map((width) => (
      <div key={width} className="flex shrink-0 gap-4">
        <div className="flex-[2]">
          <div className={cn("h-3 rounded-sm bg-foreground/15", width)} />
        </div>
        <div className="h-3 flex-1 rounded-sm bg-foreground/15" />
        <div className="h-3 flex-1 rounded-sm bg-foreground/15" />
      </div>
    ))}
  </div>
);
